import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_69566509-b9c0-48ae-b149-6b9accd67eee/artifacts/3nmi4pqp_Dynamic%20Logo%20with%20Sapphire%20Coral%20Gradient%20%288%29.png";

const Policies = () => {
  return (
    <div className="min-h-screen" style={{ backgroundColor: 'var(--background-primary)' }}>
      {/* Header */}
      <header className="nav">
        <div className="nav-content">
          <Link to="/" className="flex items-center">
            <img src={LOGO_URL} alt="Shadesense.ai" className="h-10 w-auto" />
          </Link>
          <Link to="/" className="btn-secondary flex items-center gap-2">
            <ArrowLeft className="w-4 h-4" />
            Back to Home
          </Link>
        </div>
      </header>

      {/* Content */}
      <main className="container py-16">
        <div className="max-w-3xl mx-auto">
          <p className="text-meta uppercase tracking-widest mb-4" style={{ color: 'var(--accent-primary)' }}>
            Legal
          </p>
          <h1 className="text-display mb-4" style={{ color: 'var(--text-primary)' }}>
            All Policies
          </h1>
          <p className="text-body text-secondary mb-12">
            Complete legal documentation for Shadesense.ai
          </p>

          {/* Quick Links */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-16">
            <Link to="/terms" className="card p-6 hover:shadow-lg transition-shadow">
              <h3 className="text-h3 mb-2" style={{ color: 'var(--text-primary)' }}>Terms of Use</h3>
              <p className="text-small text-secondary">Rules governing use of our service</p>
            </Link>
            <Link to="/privacy" className="card p-6 hover:shadow-lg transition-shadow">
              <h3 className="text-h3 mb-2" style={{ color: 'var(--text-primary)' }}>Privacy Policy</h3>
              <p className="text-small text-secondary">How we handle your data</p>
            </Link>
            <Link to="/cookies" className="card p-6 hover:shadow-lg transition-shadow">
              <h3 className="text-h3 mb-2" style={{ color: 'var(--text-primary)' }}>Cookie Policy</h3>
              <p className="text-small text-secondary">Our use of cookies and tracking</p>
            </Link>
          </div>

          <div className="prose prose-lg" style={{ color: 'var(--text-secondary)' }}>
            
            {/* Acceptable Use Policy */}
            <h2 className="text-h2 mt-12 mb-4" style={{ color: 'var(--text-primary)' }}>Acceptable Use Policy</h2>
            <p className="text-body mb-4">You agree not to:</p>
            <ul className="list-disc pl-6 mb-4 space-y-2">
              <li className="text-body">Upload unlawful or infringing content</li>
              <li className="text-body">Misuse, abuse, or attempt to exploit the Service</li>
              <li className="text-body">Interfere with system security or performance</li>
            </ul>
            <p className="text-body mb-8">
              Violations may result in account suspension or termination.
            </p>

            {/* Intellectual Property & DMCA Policy */}
            <h2 className="text-h2 mt-12 mb-4" style={{ color: 'var(--text-primary)' }}>Intellectual Property & DMCA Policy</h2>
            <p className="text-body mb-4">
              All intellectual property related to the Service is owned by Shadesense Inc.
            </p>
            <p className="text-body mb-4">
              Users may screenshot and share results for personal use. Embedding Service content elsewhere is not permitted.
            </p>
            <p className="text-body mb-4">
              DMCA notices may be sent to: <a href="mailto:aisalesfunnel@gmail.com" className="underline" style={{ color: 'var(--accent-primary)' }}>aisalesfunnel@gmail.com</a>
            </p>
            <p className="text-body mb-8">
              Jurisdiction: United States
            </p>

            {/* Disclaimer & Affiliate Disclosure */}
            <h2 className="text-h2 mt-12 mb-4" style={{ color: 'var(--text-primary)' }}>Disclaimer & Affiliate Disclosure</h2>
            <p className="text-body mb-4">
              Shadesense.ai provides fashion-related color analysis for informational purposes only. Results are not guaranteed and should not be considered professional styling advice.
            </p>
            <p className="text-body mb-8">
              Some product links are affiliate links. Shadesense may earn a commission from qualifying purchases at no additional cost to you. Affiliate relationships do not affect which products appear or how they are ranked.
            </p>

            {/* Contact */}
            <h2 className="text-h2 mt-12 mb-4" style={{ color: 'var(--text-primary)' }}>Contact</h2>
            <p className="text-body mb-6">
              For all legal inquiries: <a href="mailto:aisalesfunnel@gmail.com" className="underline" style={{ color: 'var(--accent-primary)' }}>aisalesfunnel@gmail.com</a>
            </p>
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="footer">
        <div className="footer-content">
          <p className="text-meta text-muted">© 2026 Shadesense Inc. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
};

export default Policies;
